import { Col, Row } from "antd";
import moment from "moment";
import { CheckTag } from "./index.styled";

export interface TimeDataType {
  key: React.Key;
  time: moment.Moment;
  disabled?: boolean;
}

interface TimesTagProps {
  times: TimeDataType[];
  selectedTimes?: React.Key[];
  block?: boolean;
  onChange?: (selectedKeys: React.Key[], times: TimeDataType[]) => void;
}
/**
 * 시간 선택 정보
 * @returns
 */
export const TimesTag: React.FC<TimesTagProps> = ({
  times = [],
  selectedTimes = [],
  block = false,

  onChange = () => void 0,
}) => {
  /**
   * 시간 변경
   * @param time
   * @param checked
   */
  const handleChange = (key: React.Key, checked: boolean) => {
    const keys = checked
      ? [...selectedTimes, key]
      : selectedTimes.filter((k) => k !== key);

    const items = times.filter(
      ({ key }) => keys.findIndex((k) => k === key) > -1
    );

    onChange(keys, items);
  };
  return (
    <Row
      gutter={block ? [8, 8] : [4, 4]}
      align="top"
      style={{ justifyItems: "stretch" }}
    >
      {times.map(({ time, key, disabled }, index) => (
        <Col key={`times-${index}`} span={block ? 12 : "auto"}>
          <CheckTag
            $block={block}
            checked={selectedTimes.findIndex((k) => k === key) > -1}
            onChange={(val) => {
              if (disabled === false) {
                handleChange(key, val);
              }
            }}
            disabled={disabled}
          >
            {time.format("HH:mm")}
          </CheckTag>
        </Col>
      ))}
    </Row>
  );
};
